import "./chart-doughnut.component.scoped.scss";
import React, { useEffect } from "react";
import { Doughnut } from 'react-chartjs-2';
import Chart from "chart.js";
import { addLeadingZero } from "src/helpers";
// import { useTranslation } from "react-i18next";

export const ChartDoughnutComponent = (props: any) => {
  // const [t] = useTranslation();

  var originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;
  Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
    draw: function() {
      originalDoughnutDraw.apply(this, arguments);

      var chart = this.chart.chart;
      var ctx = chart.ctx;
      var width = chart.width;
      var height = chart.height;
      ctx.restore();

      ctx.font = "normal normal 300 16px Roboto";
      ctx.textBaseline = "middle";

      var text = chart.config.data.text;
      var textX = Math.round((width - ctx.measureText(text).width) / 2);
      var textY = height / 2;

      ctx.fillStyle = "rgb(145, 145, 145)";
      ctx.fillText(text, textX, textY);
      ctx.save();
    },
  });
  
  const data = {
    labels: [...props.labels],
    datasets: [
      {
        data: [...props.data],
        backgroundColor: [...props.colors],
        hoverBackgroundColor: [...props.colors],
        hoverBorderColor: [...props.colors],
        borderColor: [...props.colors],
        hoverBorderWidth: 10,
      },
    ],
    text: props.total
  };
  const options = {
    legend: {
      display: false
    },
    responsive: true,
    maintainAspectRatio: false,
    cutoutPercentage: 60,
    animation: {
      animateScale: true,
    },
    tooltips: {
      callbacks: {
        // this callback is used to create the tooltip label
        label: function(tooltipItem: any, data: any) {
          // get the data label and data value to display
          // convert the data value to local string so it uses a comma seperated number
          const label = data.labels[tooltipItem.index];
          let hours = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          hours = hours ? hours.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0] : hours;
          const duration: any = `${addLeadingZero(Math.floor(Math.ceil(hours * 60) / 60))}:${addLeadingZero(Math.ceil(hours * 60) % 60)}`;
          return `${label}: ${duration}`;
        }
      }
    }
  };
  useEffect(() => {
    Chart.pluginService.register({
      beforeDraw: function(chart: any) {
      },
    });
  }, []);
  return (
    <div style={{width: "220px",height: "220px" }}>
      <Doughnut data={data} options={options} />
    </div>
  );
};
